module.exports = __webpack_public_path__ + "img/background_default.e178dd75.png";